export default __webpack_public_path__ + "static/media/aboutUs-equally@2x.af671ffe.png";